module.exports = __webpack_public_path__ + "static/anna-9ab0accdf46e3a95a77d4d59ce96ffd2.jpg";